export class Exercise {
  id: string = null;
  title: string = null;
  description: string = null;
  keyword: string[] = [];
  isPublic: boolean = false;
  author: string = null;
  owner: string = null;
  editors: string[] = [];

}

const emptyExercise: Exercise = new Exercise();

export { emptyExercise };
